<script setup lang="ts">
import {reactive, watchEffect} from "vue";
import {saving} from "@/Composables/api";
import {storeTag, updateTag} from "@/Services/Admin/admin-tags";
import {Button, Dialog, InputText, Label} from "@/Components/Library";
import {Messages} from "@/Components/Forms";
import type {Tag} from "@/Types";
import {useMainStore} from "@/Stores/store";
import tag from "@/Theme/Components/tag.ts";

const $store = useMainStore();
const bag = "admin-tag-form";

const model = defineModel<boolean>("visible");
const emit = defineEmits(["saved"]);
const props = defineProps<{
    tag?: Tag | null;
}>();

const defaultForm = {
    id: null,
    name: null,
};

const form = reactive({
    ...defaultForm,
});

const save = async () => {
    if (form.id) {
        await updateTag(form);
    } else {
        await storeTag(form);
    }

    $store.addMessage({
        type: "success",
        text: `Tag ${form.id ? "updated" : "created"} successfully`,
        bag: bag,
    });

    emit("saved");

    setTimeout(() => {
        model.value = false;
        Object.assign(form, defaultForm);
    }, 3000);
};

watchEffect(() => {
    if (props.tag) {
        form.id = props.tag.id;
        form.name = props.tag.name;
    } else {
        Object.assign(form, defaultForm);
    }
});
</script>
<template>
    <Dialog
        v-model:visible="model"
        modal
        :header="`${tag?.id ? 'Edit' : 'Add a new'} tag`"
        class="mx-8 max-h-dvh w-full overflow-y-auto sm:max-w-lg"
    >
        <form class="flex flex-col" @submit.prevent="save">
            <div class="mb-4 flex flex-col">
                <Label for="name" class="mb-1" required>Tag name</Label>
                <InputText id="name" name="name" v-model="form.name" required />
                <!-- TODO: Add fields for localized names? -->
            </div>
            <Messages :form-name="bag" class="mb-4" />
            <Button :loading="!!saving" class="bg-askr-green text-white" type="submit">Add</Button>
        </form>
    </Dialog>
</template>
<style scoped></style>
